import { css } from 'styled-components';
import { ITheme } from '@lerna-core';

export const getStyles = (theme: ITheme): ReturnType<typeof css> => css`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 16px;
  z-index: ${theme.ZINDEX.TOP_BLOCK};
`;
